import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClockSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconClockSquare"><Path d="M12.75 9V11.6893L14.8107 13.75L13.75 14.8107L11.25 12.3107V9H12.75Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM12 6.375C8.8934 6.375 6.375 8.8934 6.375 12C6.375 15.1066 8.8934 17.625 12 17.625C15.1066 17.625 17.625 15.1066 17.625 12C17.625 8.8934 15.1066 6.375 12 6.375Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClockSquare;
